import React from 'react';
import { Bot } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const AssistantMessage = ({ message }) => {
  return (
    <div className="flex justify-start items-end mb-4">
      <div className="w-9 h-9 rounded-full mr-2 bg-gradient-to-r from-blue-500 to-purple-600 flex items-center justify-center">
        <Bot className="text-white" size={20} />
      </div>
      <div className="max-w-xs lg:max-w-md px-4 py-3 bg-gray-100 text-gray-900 rounded-2xl shadow-sm">
        <div className="flex items-start space-x-2">
          <Bot className="w-5 h-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <div className="text-sm leading-relaxed prose prose-sm max-w-none">
              <ReactMarkdown 
                remarkPlugins={[remarkGfm]}
              >
                {message.content[0].text.value}
              </ReactMarkdown>
            </div>
            <p className="text-xs text-gray-500 mt-1">
              {new Date(message.created_at).toLocaleTimeString()}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssistantMessage; 